import { AdminExtraBuilder } from './adminExtra-builder';
import { AdminReservationExtra } from '../model/adminReservationExtra';
export class AdminReservationExtraBuilder {
    static buildAdminReservationExtra(data) {
        const adminExtra = new AdminReservationExtra();
        adminExtra.id = data.id;
        adminExtra.id_reservation = data.id_reservation;
        adminExtra.id_extra = data.id_extra;
        adminExtra.id_bill = data.id_bill;
        adminExtra.separated_bill = data.separated_bill == 1 ? true : false;
        adminExtra.amount = data.amount;
        adminExtra.pvp_unit = data.pvp_unit;
        adminExtra.pvp = data.pvp;
        adminExtra.vat = data.vat;
        adminExtra.base = data.base;
        adminExtra.plate = data.plate;
        adminExtra.calle = data.calle;
        adminExtra.space_number = data.space_number;
        adminExtra.price_calculation = data.price_calculation;
        adminExtra.date_requested = data.date_requested;
        adminExtra.date_started = data.date_started;
        adminExtra.date_completed = data.date_completed;
        adminExtra.date_dimissed = data.date_dimissed;
        adminExtra.out_date = data.out_date;
        adminExtra.status = data.status;
        adminExtra.notes = data.notes;
        adminExtra.reservation_status = data.reservation_status;
        adminExtra.reservation_space_extra = data.reservation_space_extra;
        adminExtra.id_invoice_profile = data.id_invoice_profile;
        adminExtra.invoice_address = data.invoice_address;
        adminExtra.invoice_city = data.invoice_city;
        adminExtra.invoice_email = data.invoice_email;
        adminExtra.invoice_name = data.invoice_name;
        adminExtra.invoice_nif = data.invoice_nif;
        adminExtra.invoice_state = data.invoice_state;
        adminExtra.invoice_zip = data.invoice_zip;
        adminExtra.invoice_country = data.invoice_country;
        adminExtra.icon = data.icon;
        try {
            if (data.product_extra) {
                if (typeof data.product_extra === 'string') {
                    adminExtra.product_extra = AdminExtraBuilder.buildAdminExtra(JSON.parse(data.product_extra));
                }
                else {
                    adminExtra.product_extra = AdminExtraBuilder.buildAdminExtra(data.product_extra);
                }
            }
        }
        catch (e) {
            adminExtra.product_extra = e;
        }
        return adminExtra;
    }
}
//# sourceMappingURL=adminReservationExtra-builder.js.map